<template>
  <div>
    <h3>{{ book.name }}</h3>
    <p>{{ book.author }}</p>
    <img :src="book.image" alt="image">
  </div>
</template>

<script>
  export default {
    name: "BookItem",
    props: ['book']
  }
</script>

<style scoped>

</style>